import { render, staticRenderFns } from "./ApplyDocEdit.vue?vue&type=template&id=23f38dbe&"
import script from "./ApplyDocEdit.vue?vue&type=script&lang=js&"
export * from "./ApplyDocEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports